Vue.component('adminStore', {
  template: templates.adminStore,
  data() {
    return {
      model: {
        edit: false,
        store: {
          id: null,
          name: null,
          active: false,
          description: null,
          price: null,
          tier: null,
          prefix: null,
          cardTier: "",
          dumpCard: 0,
          item_cooldown: null,
          standard: null,
          ultra: null,
          legendary: null,
          ultimate: null
        },
        stores: {},
        cooldownEnabled: false,
        cardTier: [
          {
            name: 'Standard Cards',
            value: 1
          },
          {
            name: 'Ultra Cards',
            value: 2
          },
          {
            name: 'Legendary Cards',
            value: 3
          },
          {
            name: 'Bone Cards',
            value: 5
          },
        ]
      }
    }
  },
  watch: {
    'model.store.tier'(newTier) {
      const c = this;
      if (newTier == 1) {
        c.model.store.dumpCard = 0;
        c.model.store.cardTier = '';
      }
    },
  },
  mounted() {
    const c = this;
    c.get();
  },
  methods: {
    get() {
      const c = this;
      let data = {};

      storeService.get()
      .then(function (response) {
        for (let d of response.data) {
          data[`${d.id}`] = d;

          const dataObject = {
            name: d.cardTier[0],
            value: parseInt(d.cardTier[1]) 
          };

          data[`${d.id}`].cardTier = dataObject;
          
        }
        c.model.stores = data;

      })
      .catch(function (response){
        console.log(response)
      })
     
    },
    edit(id) {
      const c = this;
      let data = c.model.stores[`${id}`];

      if (id == c.model.store.id) {
        c.model.edit = false;
      } else {
        c.model.edit = true;
      }

      c.model.store = {
        id: id,
        name: data.name,
        description: data.description,
        price: data.price,
        active: data.active,
        prefix: data.prefix,
        tier: data.tier,
        cardTier: data.cardTier,
        dumpCard: data.dumpCard,
        item_cooldown: data.item_cooldown,
        standard: data.standard,
        ultra: data.ultra,
        legendary: data.legendary,
        ultimate: data.ultimate,
        image: data.image || null
      }

      if(data.item_cooldown > 0){
        c.model.cooldownEnabled = true;
      }

      console.log(c.model.store)

    },
    add() {
      const c = this;
      c.model.edit = true;
    },
    save() {
      const c = this;

      const data = c.model.store;

      if (!data.name) {
        utils.alert.error('Name is required');
        return;
      }

      if (!data.description) {
        utils.alert.error('Description is required');
        return;
      }

      if (!data.prefix) {
        utils.alert.error('Prefix is required');
        return;
      }

      
      storeService.save(data)
        .then(function (response) {
          console.log(data)
          if (data.id) {
            c.model.stores[`${data.id}`] = data;
          } else {
            data.id = response.data.id;
            c.model.stores[`${data.id}`] = data;
          }

          c.reset();
          
          utils.alert.success('Saved!');
          
        })
        .catch(function (error) {
          utils.alert.error('Failed to save.');
        });
    },
    selectedTier() {
      const c = this;

    },
    handleImageUpload(result) {
      const c = this;
      if (!result.files || !result.files[0]) return;

      const filename = result.files[0].filename || result.files[0].name;
      const ext = filename.split('.').pop().toLowerCase();
      const storeId = c.model.store.id;
      const imagePath = `/images/store/${storeId}/${storeId}.${ext}?t=${Date.now()}`;

      c.model.store.image = imagePath;
      if (c.model.stores[`${storeId}`]) {
        Vue.set(c.model.stores[`${storeId}`], 'image', imagePath);
      }
    },
    reset() {
      const c = this;
      c.model.edit = false;

      c.model.store = {
        id: null,
        name: null,
        active: false,
        description: null,
        price: null,
        tier: null,
        item_cooldown: null,
        prefix: null,
        cardTier: null,
        dumpCard: null,
        standard: null,
        ultra: null,
        legendary: null,
        ultimate: null,
        image: null
      }
    }
  }
});